export default __webpack_public_path__ + "static/media/C4.dfc08074.svg";